import React  from 'react';
import { Route,Switch} from 'react-router-dom';

import Student from './Student';
import StudentAddEdit from './Student/addEdit'; 

import StudentFees from './StudentFees';
import StudentFeesAddEdit from './StudentFees/addEdit'; 
import StudentFeesPayDueAmount from './StudentFees/payDueAmount'; 
 
export  const Studentroutes = [
    {
        path: '/student',
        name:'Student',
        component: Student,
        show:true,
    },
    {
        path: '/Student-action',
        component: StudentAddEdit
    },
    {
        path: '/Student-action/:id', 
        component: StudentAddEdit
    },
    {
        path: '/student-fees',
        name:'Student Fees',
        component: StudentFees,
        show:true,
    },
    {
        path: '/student-fees-action',
        component: StudentFeesAddEdit
    },
    {
        path: '/student-fees-action/:id', 
        component: StudentFeesAddEdit
    },
    {
        path: '/student-fees-due/:id', 
        component: StudentFeesPayDueAmount
    } 
];

const Students = (props) => {
    return(
        <Switch>
            {Studentroutes.map((route) => 
                <Route exact
                    key={route.path}
                    path={`${props.match.url}${route.path}`}
                    component={route.component}
                />
            )} 
        </Switch> );
};
export default Students; 


// WEBPACK FOOTER //
// ./src/components/Student/Index.js